<template>

<div >

<div>

  <v-app id="inspire">
    <v-content>
      <v-container  fluid>

        <v-row >

         <v-col cols="12" sm="8" md="12">
              <img :src='image'  ref='image' style='margin-left:10px;' width='70%' height='250px'><br>
<label>Adicionar ficheiro
        <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
      </label>

       <br>
    <div class="large-12 medium-12 small-12 cell">
      <div v-for="(file, key) in filesUpload" class="file-listing">
        <v-icon small v-if="file.name.includes('.pdf')">picture_as_pdf</v-icon>
        <v-icon small v-if="file.name.includes('.pptx')">slideshow</v-icon>
        <v-icon small v-if="file.name.includes('.mp3')">music_note</v-icon>
        <v-icon small v-if="file.name.includes('.jpg') || file.name.includes('.gif' || file.name.includes('.png'))">photo</v-icon>
        {{ file.name }}<span class="remove-file" v-on:click="removeFile( key )">
          <v-icon small >delete</v-icon>
          </span>
          </div>
    </div>

    </v-col>
    <v-col cols="12" sm="8" md="2">
        <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>

         </v-col>
     <v-col cols="12" sm="8" md="2">
     <v-card-actions>
      <v-spacer></v-spacer>
    <v-btn
         :disabled="!valid"
        :loading="isUpdating"
        depressed
        color="green"
        class="ma-2 white--text"
        fab
        @click="submitFiles()">
       <v-icon large dark >cloud_upload</v-icon></v-btn>

    </v-card-actions>
       </v-col>
<v-col cols="12" sm="4" md="2">
       <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:blue;">info
          </v-icon>
        </template>
        <span>Deve conter no máximo 4 ficheiros</span>
      </v-tooltip>
      </v-col>
        </v-row>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
let FormData = require('form-data')
const ls = require('local-storage')
export default {
  data () {
    return {
      image: ls.get('urlReport') + 'readfile/upload.jpg',
      filesUpload: [],
      progresso: false,
      isUpdating: false,
      valid: false,
      refs: null
    }
  },
  watch: {

    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    }
  },
  created () {
    this.refs = this.$refs
  },
  methods: {
    addFiles () {
      this.$refs.files.click()
    },
    async submitFiles () {
      if (this.filesUpload.length <= 4) {
        this.progresso = true
        let nome = {
          nomeFile: '',
          operacao: 0,
          path: 'uploadFiles'
        }
        let formData = new FormData()
        let resposta = true

        //  Iteate over any file sent over appending the files
        //   to the form data.

        formData.append('upload', JSON.stringify(nome)) // this must always come first ahaed of loop
        for (let i = 0; i < this.filesUpload.length; i++) {
          let file = this.filesUpload[i]
          formData.append('files[' + i + ']', file)
        }

        // formData.append('first_name', 'Dan')
        try {
          axios.post(ls.get('urlReport') + 'upload-files', formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function (response) {
            if (response.status !== null && response.status === 200) { resposta = true } else resposta = false
          }
          )

          if (resposta) {
            this.filesUpload = []
            this.valid = false
          }
          this.progresso = false
        } catch (error) {
          this.progresso = false
          console.log(error)
        }
      }
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload () {
      if (this.$refs.files.files.length > 0 && this.filesUpload.length < 4)
      /*
          Adds the uploaded file to the files array
        */
      {
        this.valid = true
        this.filesUpload.push(this.$refs.files.files[0])
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile (key) {
      this.filesUpload.splice(key, 1)
      if (this.filesUpload.length === 0) this.valid = false
    }
  }
}
</script>
